import ManualBillingDocumentEffectiveAt from '@/generated/controls/manualBillingDocument/ManualBillingDocumentEffectiveAt.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: ManualBillingDocumentEffectiveAt
})
